import { type FunctionComponent } from 'react';
import { Badge } from '../../common-components/badge/badge.component';
import ArrowDropDownIcon from '../../svgs/arrow-drop-down.svg';
import OmniProBadgeIconSvg from '../../svgs/omni-pro-badge-icon.svg';
import { accountProBadge, accountGreeting } from './account-dropdown-toggle.css';

export type AccountDropdownToggleProps = {
	firstName?: string;
	isPro?: boolean;
	isOpen?: boolean;
	unreadNotificationCount: number;
};

export const AccountDropdownToggle: FunctionComponent<AccountDropdownToggleProps> = ({
	firstName,
	isPro = false,
	isOpen = false,
	unreadNotificationCount
}) => {
	const theme = isOpen ? 'header-dropdown-open theme-primary-darker' : 'header-dropdown-closed theme-primary-dark';

	let accountText = 'Account';

	if (!firstName) {
		accountText = 'Orders & Returns';
	}

	return (
		<div className={`hover-theme-primary ${theme} flex items-center pointer`} data-tracking="nav:menu:My Account">
			<div className="flex-column ml0">
				<span className={`f7 absolute overflow-hidden nowrap ${accountGreeting}`} data-automation="account-greeting">
					{firstName ? <>Hi, {firstName}</> : <>Log In</>}
				</span>
				<div className="f5 flex flex-row items-center b truncate f6 lh-copy relative">
					{unreadNotificationCount > 0 && (
						<div className="db-m dn-l mr1">
							<Badge count={unreadNotificationCount} hideCount={true} noMargin={true} />
						</div>
					)}
					{isPro && <OmniProBadgeIconSvg className={`${accountProBadge} pr1 f7 theme-pro`} data-testid="OmniProBadgeIconSvg" />}
					<p className="truncate mv0">{accountText}</p>
					<ArrowDropDownIcon className="v-mid dn dib-l f4-ns" />
				</div>
			</div>
		</div>
	);
};
